export enum Activity {
  InTransit = 'In Transit',
  Searching = 'Searching',
  Fishing = 'Fishing',
  ReturningToPort = 'Returning to Port',
  Transhipment = 'Transhipment',
}
